enum BlockType {
    Default, Quotation, Implementation
}


enum OtherType{
    Bla, Foo
}

export { BlockType, OtherType }

